import { Question, Section, TestRes } from '../response/test.response';

export const getClampedElapsedSeconds = (
  startTime: number,
  alreadyTaken = 0,
  duration?: number,
): number => {
  if (!startTime || startTime <= 0) {
    return 0;
  }

  const elapsed = (Date.now() - startTime) / 1000;
  if (!Number.isFinite(elapsed) || elapsed < 0) {
    return 0;
  }

  if (duration == null || duration <= 0) {
    return elapsed;
  }

  return Math.min(elapsed, Math.max(0, duration - alreadyTaken));
};

const capToDuration = (value: number, duration?: number): number => {
  if (!duration || duration <= 0) {
    return value;
  }
  return Math.min(Math.max(0, value), duration);
};

export const applyElapsedToTest = (
  testRes: TestRes,
  elapsed: number,
): TestRes => {
  if (!elapsed) {
    return testRes;
  }

  const duration = testRes.duration;

  return {
    ...testRes,
    timeTaken: capToDuration((testRes.timeTaken || 0) + elapsed, duration),
    sectionList: testRes.sectionList.map((section: Section) => {
      if (!section.active) {
        return section;
      }

      return {
        ...section,
        timeTaken: capToDuration((section.timeTaken || 0) + elapsed, duration),
        questionList: section.questionList.map((question: Question) => {
          if (!question.active) {
            return question;
          }

          return {
            ...question,
            timeTaken: capToDuration(
              (question.timeTaken || 0) + elapsed,
              duration,
            ),
          };
        }),
      };
    }),
  };
};

export const secondsToHMS = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  const formattedHours = hours.toFixed(0).toString().padStart(2, '0');
  const formattedMinutes = minutes.toFixed(0).toString().padStart(2, '0');
  const formattedSeconds = remainingSeconds
    .toFixed(0)
    .toString()
    .padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};
